"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const currency_1 = __importStar(require("@helium/currency"));
const DataModel_1 = __importDefault(require("./DataModel"));
function integerToBalance(integerValue) {
    return new currency_1.default(integerValue, currency_1.CurrencyType.networkToken);
}
class Reward extends DataModel_1.default {
    constructor(client, rewards) {
        super();
        this.client = client;
        this.account = rewards.account;
        this.amount = integerToBalance(rewards.amount);
        this.block = rewards.block;
        this.gateway = rewards.gateway;
        this.hash = rewards.hash;
        this.timestamp = rewards.timestamp;
    }
    get data() {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _a = this, { client } = _a, rest = __rest(_a, ["client"]);
        return Object.assign({}, rest);
    }
}
exports.default = Reward;
//# sourceMappingURL=Reward.js.map